import { colorsTypes, FileTypeEnum } from 'utils'

import type { FilesGroupsFragment } from 'gql/__generated__/graphql'
import type { FinderItem } from 'store/models'

import archiveSvg from './Archive.svg?react'
import audioSvg from './Audio.svg?react'
import * as s from './FinderFileIcons.module.scss'
import IconFolderComponentSvg from './Folder.svg?react'
import videoSvg from './Video.svg?react'

const EnumIconsByFileType = {
  [FileTypeEnum.AUDIO]: audioSvg,
  [FileTypeEnum.VIDEO]: videoSvg,
  [FileTypeEnum.TEXT]: archiveSvg,
  [FileTypeEnum.APPLICATION]: archiveSvg,
  [FileTypeEnum.TRANSLATE]: archiveSvg,
  [FileTypeEnum.IMAGE]: archiveSvg,
  [FileTypeEnum.FONT]: archiveSvg,
  [FileTypeEnum.CAPTIONS]: archiveSvg,
}

const FinderFileIcons = ({ typeFile, item }: { typeFile?: FileTypeEnum; item: FinderItem }) => {
  // Make sure typeFile is a valid FileTypeEnum value
  const validFileType =
    typeFile && Object.values(FileTypeEnum).includes(typeFile) ? typeFile : FileTypeEnum.APPLICATION

  const IconComponent = EnumIconsByFileType[validFileType]

  return (
    <>
      {typeFile && (
        <div className={s.fileItem}>
          {typeFile === FileTypeEnum.IMAGE && item.img && (
            <img alt='img' className={s.img} src={item.img} />
          )}
          {typeFile !== FileTypeEnum.IMAGE && IconComponent && <IconComponent />}
        </div>
      )}
      {!typeFile && (
        <div
          className={s.folderItem}
          style={{ color: (item as FilesGroupsFragment)?.color || colorsTypes.purpure }}
        >
          <IconFolderComponentSvg />
        </div>
      )}
    </>
  )
}

export default FinderFileIcons
